import {encode} from 'js-base64'

const TARGET_URL_QUERY_PARAM_NAME = 'roxTargetUrl'
const AUTH_QUERY_PARAM_NAME = 'roxAuth'

export default class ProxyConfig {
  _proxyUrl = ''
  _proxyAuthHeader = ''
  _proxySettings = false as any
  _proxyAuthHeaderEncoded

  constructor(proxySettings?) {
    if (proxySettings) {
      this._proxySettings = {...proxySettings}

      // calculating constants
      this._proxyUrl = `${this._proxySettings.protocol}://${this._proxySettings.host}${
        this._proxySettings.port ? `:${this._proxySettings.port}` : ''
      }`
      if (
        this._proxySettings.auth &&
        this._proxySettings.auth.username &&
        this._proxySettings.auth.password
      ) {
        this._proxyAuthHeader = `Basic ${encode(
          `${this._proxySettings.auth.username}:${this._proxySettings.auth.password}`
        )}`
        this._proxyAuthHeaderEncoded = encodeURIComponent(this._proxyAuthHeader)
      }
    }
  }

  applyProxyToRequest(request) {
    if (this._proxySettings) {
      request.options = request.options ? {...request.options} : {}
      const options = request.options
      options.params = options.params || {}
      options.params[TARGET_URL_QUERY_PARAM_NAME] = request.url
      if (this._proxyAuthHeader) {
        options.params[AUTH_QUERY_PARAM_NAME] = this._proxyAuthHeader
      }
      request.url = this._proxyUrl
    }
  }

  applyProxyToSseRequest(request) {
    if (this._proxySettings) {
      request.url = `${
        this._proxyUrl
      }?${TARGET_URL_QUERY_PARAM_NAME}=${encodeURIComponent(request.url)}`
      if (this._proxyAuthHeaderEncoded) {
        request.url = `${request.url}&${AUTH_QUERY_PARAM_NAME}=${this._proxyAuthHeaderEncoded}`
      }
    }
  }

  get proxyUrl() {
    return this._proxyUrl
  }
}
